/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { type ElementType } from 'react';
import { type MessageDescriptor, useIntl } from '@atlassian/jira-intl';

export const useFormattedMessageAndIcon = (
	message: MessageDescriptor,
	Icon: ElementType,
): {
	formattedMessage: string;
	icon: React.JSX.Element;
} => {
	const { formatMessage } = useIntl();

	const formattedMessage = formatMessage(message);
	const icon = <Icon spacing="spacious" color="currentColor" aria-hidden="true" />;

	return { formattedMessage, icon };
};
